import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getConfigAddressFields:[],
  getConfigAddressFieldsSuccess:['data'],
  setPickupLocation: ['pickupLocations'],
});

export const shippingAddressTypes = Types;
export default Creators;
